import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataexchangeService {

  public static autoUpdateInProgress: boolean;

  private _reportAutoUpdate: BehaviorSubject<boolean> = new BehaviorSubject(null);
  reportAutoUpdate: Observable<boolean> = this._reportAutoUpdate.asObservable();

  setReportAutoUpdate(value: boolean) {
    this._reportAutoUpdate.next(value)
  }

  resetObservablesToDefaultValue() {
    this.setReportAutoUpdate(null);
  }
}
